import {
  createAIImageApi,
  getGeneratedClipartApi,
  saveAIClipartApi
} from '@/api/generateAI';
import {
  BEDROCK_IMAGE_SIZES_TYPE,
  BEDROCK_IMAGE_TYPES_TYPE
} from '@/common/constants';

export const useGenerateClipart = () => {
  const generateClipart = async ({ describe, communityId }) => {
    const cliparts = await createAIImageApi({
      prompt: describe,
      imageType: BEDROCK_IMAGE_TYPES_TYPE.CLIPART,
      size: BEDROCK_IMAGE_SIZES_TYPE.W512xH512,
      communityId: +communityId
    });
    return cliparts;
  };
  return {
    generateClipart,
    saveGeneratedCLipart: saveAIClipartApi,
    getGeneratedClipart: getGeneratedClipartApi
  };
};
